/**
 * Authority Officers View
 * Dedicated route component for Authority officers management
 * Similar to CVO officers but department is auto-filled from current logged-in officer's department
 */

import React from 'react';
import OfficersView from '../cvo/OfficersView';
import { useSelector } from 'react-redux';
import { selectAuthorityDashboard } from '../../store/slices/dashboardSlice';
import authService from '../../services/authService';

const AuthorityOfficersView = () => {
  const authorityDashboard = useSelector(selectAuthorityDashboard);
  
  // Get current logged-in officer's department from dashboard or user data
  const getCurrentOfficerDepartment = () => {
    // Try to get from dashboard data first (stored in Redux)
    if (authorityDashboard?.data?.user) {
      const user = authorityDashboard.data.user;
      // Department comes as user.departments.id from dashboard API
      if (user.departments && user.departments.id) {
        return user.departments.id;
      }
      // Fallback to other possible field names
      return user.department_id || user.department?.id || user.departments_id || null;
    }
    
    // Fallback to user data from localStorage
    const userData = authService.getCurrentUser();
    if (userData) {
      // Check for departments.id first (from dashboard API response)
      if (userData.departments && userData.departments.id) {
        return userData.departments.id;
      }
      // Fallback to other possible field names
      return userData.department_id || userData.department?.id || userData.departments_id || null;
    }
    
    return null;
  };

  const currentOfficerDepartment = getCurrentOfficerDepartment();

  return (
    <OfficersView
      hideDepartmentField={true}
      defaultDepartment={currentOfficerDepartment}
      role="authority"
    />
  );
};

export default AuthorityOfficersView;

